const catalogConfig = {
  catalogInitialState: "swiper"
};

export default catalogConfig;